import { RepliersListing } from '../../types/repliers/RepliersListing';

// TODO: currently this function's return value isn't actually used when writing to the database, because isFsbo is a generated column. But we should make it a normal column the next time we reseed, at which point this value will be used
export default function getIsFsboFromRepliersListing(
  repliersListing: RepliersListing,
): boolean {
  const brokerageName = repliersListing.office?.brokerageName;

  if (!brokerageName) return false;

  const uppercasedBrokerageName = brokerageName.toUpperCase();

  return (
    uppercasedBrokerageName.startsWith('PG DIRECT') ||
    uppercasedBrokerageName.startsWith('ICI SOURCE') ||
    uppercasedBrokerageName.startsWith('EASY LIST') ||
    uppercasedBrokerageName.startsWith('EASYLIST') ||
    uppercasedBrokerageName.startsWith('CANADA HOME GROUP') ||
    uppercasedBrokerageName.startsWith('BODE')
  );
}
